import React, { Fragment } from 'react'
import Logo from '../../assets/Logo.png'
import './style.scss'

const BaseNavbar = ({ headerText }) => (
  <Fragment>
    <div className='navbar'>
      <div>
        <img src={Logo} alt='logo_mellro' className='navbar_logo' />
      </div>
      <div className='navbar_header'>
        <div className='navbar_title'>
          <div className='navbar_text'>{headerText}</div>
        </div>
      </div>
    </div>
  </Fragment>
)

// TODO: use ts
// BaseNavbar.propTypes = {
//   handleChange: PropTypes.string,
// }

export default BaseNavbar
